(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uc-print-quote"] && !Shopify.designMode) return;
  try {
    (() => {
    const parsePriceToCents = (value) => Math.round(Number.parseFloat(value || '0') * 100);

    const getRootPath = () => {
      const root = window.Shopify?.routes?.root || '/';
      return root.endsWith('/') ? root : `${root}/`;
    };

    document.querySelectorAll('.uc-print-quote').forEach((root) => {
      const form = root.querySelector('.uc-print-quote__form');
      const country = root.querySelector('#UcQuoteCountry');
      const province = root.querySelector('#UcQuoteProvince');
      const provinceText = root.querySelector('#UcQuoteProvinceText');
      const provinceSelectField = root.querySelector('[data-province-select-field]');
      const provinceTextField = root.querySelector('[data-province-text-field]');
      const zip = root.querySelector('#UcQuoteZip');
      const customerName = root.querySelector('#UcQuoteCustomerName');
      const companyName = root.querySelector('#UcQuoteCompanyName');
      const customerEmail = root.querySelector('#UcQuoteEmail');
      const customerNotes = root.querySelector('#UcQuoteNotes');
      const discountInput = root.querySelector('#UcQuoteDiscount');
      const discountButton = root.querySelector('.uc-print-quote__apply-discount');
      const discountStatus = root.querySelector('.uc-print-quote__discount-status');
      const fulfillmentInputs = Array.from(root.querySelectorAll('input[name="uc_quote_fulfillment"]'));
      const deliveryFields = root.querySelector('.uc-print-quote__delivery-fields');
      const rates = root.querySelector('.uc-print-quote__rates');
      const rateOptions = root.querySelector('.uc-print-quote__rate-options');
      const status = root.querySelector('.uc-print-quote__status');
      const printButton = root.querySelector('.uc-print-quote__print');
      const calculateButton = root.querySelector('.uc-print-quote__calculate');
      const currency = root.dataset.currency || 'USD';
      let selectedRate = null;
      let activeDiscountCode = '';
      let activeQuoteNumber = '';
      let activeQuotePdfUrl = '';
      const notificationQueueKey = 'ucPrintQuoteNotifications';

      const setPdfLink = (url = '', filename = '') => {
        activeQuotePdfUrl = url;
        if (url) {
          printButton.href = url;
          printButton.target = '_blank';
          printButton.rel = 'noopener';
          printButton.download = filename || `${activeQuoteNumber}.pdf`;
          printButton.setAttribute('aria-disabled', 'false');
          return;
        }
        printButton.removeAttribute('href');
        printButton.removeAttribute('target');
        printButton.removeAttribute('rel');
        printButton.removeAttribute('download');
        printButton.setAttribute('aria-disabled', 'true');
      };

      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);

      const setStatus = (message, tone = '') => {
        status.textContent = message;
        status.dataset.tone = tone;
      };

      const setDiscountStatus = (message, tone = '') => {
        discountStatus.textContent = message;
        discountStatus.dataset.tone = tone;
      };

      const generateQuoteRequestId = () => {
        const datePart = new Date().toISOString().slice(0, 10).replaceAll('-', '');
        const bytes = new Uint8Array(6);
        if (window.crypto?.getRandomValues) {
          window.crypto.getRandomValues(bytes);
        } else {
          for (let index = 0; index < bytes.length; index += 1) {
            bytes[index] = Math.floor(Math.random() * 256);
          }
        }
        const randomPart = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
        return `UCQR-${datePart}-${randomPart}`;
      };

      const readNotificationQueue = () => {
        try {
          const value = JSON.parse(window.localStorage.getItem(notificationQueueKey) || '{}');
          return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
        } catch (error) {
          return {};
        }
      };

      const writeNotificationQueue = (queue) => {
        try {
          window.localStorage.setItem(notificationQueueKey, JSON.stringify(queue));
        } catch (error) {
        }
      };

      const queueQuoteNotification = (payload) => {
        const queue = readNotificationQueue();
        queue[payload.quoteNumber] = payload;
        writeNotificationQueue(queue);
      };

      const removeQuoteNotification = (quoteNumber) => {
        const queue = readNotificationQueue();
        delete queue[quoteNumber];
        writeNotificationQueue(queue);
      };

      const sendQuoteNotification = async (payload) => {
        for (let attempt = 0; attempt < 3; attempt += 1) {
          try {
            const response = await fetch(root.dataset.quoteEndpoint, {
              method: 'POST',
              credentials: 'same-origin',
              keepalive: true,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload),
            });
            const result = await response.json().catch(() => ({}));
            if (response.ok && result.ok) {
              removeQuoteNotification(payload.quoteNumber);
              return result;
            }
          } catch (error) {
          }
          await wait(500 * (attempt + 1));
        }
        console.warn(`Quote ${payload.quoteNumber} is queued for internal notification retry.`);
        return null;
      };

      const buildQuoteNotification = (emailCustomerCopy = false) => {
        const fulfillment = root.querySelector('input[name="uc_quote_fulfillment"]:checked');
        const needsDestination = fulfillment?.value === 'local_delivery' || fulfillment?.value === 'shipping';
        const provinceValue = needsDestination
          ? province.disabled
            ? provinceText.value.trim()
            : province.value
          : '';
        const hasAppliedDiscountCode = Boolean(activeDiscountCode);
        const destinationDisplay = needsDestination
          ? [provinceValue, zip.value.trim(), country.value].filter(Boolean).join(', ')
          : root.dataset.pickupDestination;
        const items = Array.from(root.querySelectorAll('.uc-print-quote__item')).map((item) => {
          const originalUnitPriceCents = Number(item.dataset.originalUnitPriceCents || item.dataset.unitPriceCents || 0);
          const originalLineTotalCents = Number(item.dataset.originalLineTotalCents || item.dataset.lineTotalCents || 0);
          return {
            variantId: item.dataset.variantId,
            quantity: Number(item.dataset.quantity || 0),
            title: item.dataset.title || '',
            variant: item.dataset.variant || '',
            sku: item.dataset.sku || '',
            sdsUrl: item.dataset.sdsUrl || '',
            tdsUrl: item.dataset.tdsUrl || '',
            originalUnitPriceCents,
            unitPriceCents: hasAppliedDiscountCode
              ? Number(item.dataset.unitPriceCents || 0)
              : originalUnitPriceCents,
            originalLineTotalCents,
            lineTotalCents: hasAppliedDiscountCode
              ? Number(item.dataset.lineTotalCents || 0)
              : originalLineTotalCents,
          };
        });
        const originalCartTotalCents = items.reduce(
          (total, item) => total + item.originalLineTotalCents,
          0
        );
        return {
          quoteNumber: activeQuoteNumber,
          customerName: customerName.value.trim(),
          companyName: companyName.value.trim(),
          quoteFor: [customerName.value.trim(), companyName.value.trim()].filter(Boolean).join(' — '),
          customerEmail: customerEmail.value.trim(),
          customerNotes: customerNotes.value.trim(),
          emailCustomerCopy,
          currency,
          cartTotalCents: hasAppliedDiscountCode
            ? Number(root.dataset.cartTotalCents || 0)
            : originalCartTotalCents,
          discountCents: hasAppliedDiscountCode ? Number(root.dataset.discountCents || 0) : 0,
          discountCode: activeDiscountCode,
          fulfillment: {
            code: fulfillment?.value || '',
            label: selectedRate?.presentment_name || selectedRate?.name || '',
            shippingCents: parsePriceToCents(selectedRate?.price),
          },
          destination: {
            country: needsDestination ? country.value : '',
            province: provinceValue,
            zip: needsDestination ? zip.value.trim() : '',
            display: destinationDisplay,
          },
          items,
        };
      };

      const createActiveQuote = async (rate, readyMessage) => {
        selectedRate = rate;
        activeQuoteNumber = generateQuoteRequestId();
        setPdfLink();
        setStatus(root.dataset.pdfGeneratingMessage);
        const payload = buildQuoteNotification();
        queueQuoteNotification(payload);
        const result = await sendQuoteNotification(payload);
        if (result?.quotePdfUrl?.startsWith('https://')) {
          activeQuoteNumber = result.quoteNumber || activeQuoteNumber;
          setPdfLink(result.quotePdfUrl, result.quotePdfName);
          setStatus(readyMessage);
          return;
        }
        setStatus(root.dataset.pdfErrorMessage, 'error');
      };

      const rebuildProvinces = () => {
        const option = country.options[country.selectedIndex];
        let provinces = [];
        try {
          provinces = JSON.parse(option?.dataset?.provinces || '[]');
        } catch (error) {
          provinces = [];
        }

        const previousValue = province.value || provinceText.value.trim() || root.dataset.defaultProvince;
        province.replaceChildren();
        if (provinces.length > 0) {
          const provincePlaceholder = document.createElement('option');
          provincePlaceholder.value = '';
          provincePlaceholder.textContent = root.dataset.selectProvinceLabel;
          province.append(provincePlaceholder);
        }
        provinces.forEach(([value, label]) => {
          const provinceOption = document.createElement('option');
          provinceOption.value = value;
          provinceOption.textContent = label;
          province.append(provinceOption);
        });

        const fulfillmentValue = root.querySelector('input[name="uc_quote_fulfillment"]:checked')?.value;
        const needsDestination = fulfillmentValue === 'local_delivery' || fulfillmentValue === 'shipping';
        const usesProvinceSelect = needsDestination && provinces.length > 0;
        const usesProvinceText = needsDestination && provinces.length === 0;
        provinceSelectField.hidden = !usesProvinceSelect;
        provinceTextField.hidden = !usesProvinceText;
        province.disabled = !usesProvinceSelect;
        province.required = usesProvinceSelect;
        provinceText.disabled = !usesProvinceText;
        provinceText.required = usesProvinceText;
        if (previousValue && provinces.some(([value]) => value === previousValue)) {
          province.value = previousValue;
        } else {
          province.value = '';
        }
        provinceText.value = usesProvinceText ? previousValue : '';
      };

      const resetRates = () => {
        selectedRate = null;
        activeQuoteNumber = '';
        setPdfLink();
        rates.hidden = true;
        rateOptions.replaceChildren();
      };

      const updateFulfillmentFields = () => {
        const fulfillment = root.querySelector('input[name="uc_quote_fulfillment"]:checked');
        const needsDestination = fulfillment?.value === 'local_delivery' || fulfillment?.value === 'shipping';
        deliveryFields.hidden = !needsDestination;
        country.disabled = !needsDestination;
        country.required = needsDestination;
        zip.disabled = !needsDestination;
        zip.required = needsDestination;
        rebuildProvinces();
        resetRates();
        setStatus(fulfillment ? root.dataset.selectMethodMessage : '');
      };

      const shippingParameters = () => {
        const parameters = new URLSearchParams();
        parameters.set('shipping_address[country]', country.value);
        parameters.set('shipping_address[zip]', zip.value.trim());
        const provinceValue = province.disabled ? provinceText.value.trim() : province.value;
        if (provinceValue) {
          parameters.set('shipping_address[province]', provinceValue);
        }
        return parameters;
      };

      const wait = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

      const fetchShippingRates = async () => {
        const parameters = shippingParameters();
        const rootPath = getRootPath();
        const prepareResponse = await fetch(`${rootPath}cart/prepare_shipping_rates.json?${parameters}`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!prepareResponse.ok) throw new Error(root.dataset.unavailableMessage);

        for (let attempt = 0; attempt < 12; attempt += 1) {
          await wait(attempt === 0 ? 250 : 750);
          const response = await fetch(`${rootPath}cart/async_shipping_rates.json?${parameters}`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error(root.dataset.unavailableMessage);

          const data = await response.json();
          if (data && Array.isArray(data.shipping_rates)) return data.shipping_rates;
        }

        throw new Error(root.dataset.delayedMessage);
      };

      const renderShippingRates = (shippingRates) => {
        rateOptions.replaceChildren();
        shippingRates.forEach((rate, index) => {
          const label = document.createElement('label');
          const input = document.createElement('input');
          const name = document.createElement('span');
          const price = document.createElement('strong');
          input.type = 'radio';
          input.name = 'uc_quote_shipping_rate';
          input.value = String(index);
          input.required = true;
          name.textContent = rate.presentment_name || rate.name;
          price.textContent = money(parsePriceToCents(rate.price));
          input.addEventListener('change', () => {
            void createActiveQuote(rate, root.dataset.shippingQuoteReadyMessage);
          });
          label.append(input, name, price);
          rateOptions.append(label);
        });
        rates.hidden = false;
      };

      const updateCartQuoteData = (cartData) => {
        root.dataset.cartTotalCents = String(cartData.total_price || 0);
        root.dataset.discountCents = String(cartData.total_discount || 0);

        const quoteItems = Array.from(root.querySelectorAll('.uc-print-quote__item'));
        const cartItems = Array.isArray(cartData.items) ? cartData.items : [];
        quoteItems.forEach((item, index) => {
          const cartItem = cartItems[index];
          if (!cartItem) return;
          item.dataset.originalUnitPriceCents = String(cartItem.original_price || cartItem.final_price || 0);
          item.dataset.unitPriceCents = String(cartItem.final_price || 0);
          item.dataset.originalLineTotalCents = String(cartItem.original_line_price || cartItem.final_line_price || 0);
          item.dataset.lineTotalCents = String(cartItem.final_line_price || 0);
        });
      };

      discountButton.addEventListener('click', async () => {
        const code = discountInput.value.trim();
        if (!code) {
          setDiscountStatus(root.dataset.discountEnterMessage, 'error');
          discountInput.focus();
          return;
        }

        const previousDiscountCents = Number(root.dataset.discountCents || 0);
        discountButton.disabled = true;
        setDiscountStatus(root.dataset.discountApplyingMessage);
        resetRates();

        try {
          const response = await fetch(`${getRootPath()}cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ discount: code }),
          });

          if (!response.ok) throw new Error(root.dataset.discountErrorMessage);

          const cartData = await response.json();
          updateCartQuoteData(cartData);
          const codeEntries = Array.isArray(cartData.discount_codes) ? cartData.discount_codes : [];
          const matchingEntry = codeEntries.find((entry) => String(entry.code || '').toLowerCase() === code.toLowerCase());
          const currentDiscountCents = Number(cartData.total_discount || 0);
          const appliedToCart = matchingEntry?.applicable === true || currentDiscountCents > previousDiscountCents;

          activeDiscountCode = appliedToCart ? code : '';
          try {
            if (appliedToCart) {
              window.sessionStorage.setItem('ucPrintQuoteDiscountCode', code);
            } else {
              window.sessionStorage.removeItem('ucPrintQuoteDiscountCode');
            }
          } catch (error) {
          }

          setDiscountStatus(
            appliedToCart ? root.dataset.discountAppliedMessage : root.dataset.discountCheckoutMessage
          );
        } catch (error) {
          activeDiscountCode = '';
          setDiscountStatus(error.message || root.dataset.discountErrorMessage, 'error');
        } finally {
          discountButton.disabled = false;
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        resetRates();
        const fulfillment = root.querySelector('input[name="uc_quote_fulfillment"]:checked');
        if (!fulfillment) {
          setStatus(root.dataset.selectMethodMessage, 'error');
          return;
        }

        if (!form.reportValidity()) return;

        if (fulfillment.value === 'shipping') {
          calculateButton.disabled = true;
          setStatus(root.dataset.calculatingMessage);
          try {
            const shippingRates = await fetchShippingRates();
            if (shippingRates.length === 0) {
              setStatus(root.dataset.noRatesMessage, 'error');
              return;
            }
            renderShippingRates(shippingRates);
            setStatus(root.dataset.selectRateMessage);
          } catch (error) {
            setStatus(error.message || root.dataset.unavailableMessage, 'error');
          } finally {
            calculateButton.disabled = false;
          }
          return;
        }

        const label = fulfillment.dataset.label;
        void createActiveQuote(
          { name: label, presentment_name: label, price: '0.00' },
          root.dataset.quoteReadyMessage
        );
      });

      printButton.addEventListener('click', (event) => {
        if (!activeQuotePdfUrl) event.preventDefault();
      });

      country.value = root.dataset.defaultCountry || 'United States';
      rebuildProvinces();
      fulfillmentInputs.forEach((input) => input.addEventListener('change', updateFulfillmentFields));
      country.addEventListener('change', () => {
        root.dataset.defaultProvince = '';
        province.value = '';
        provinceText.value = '';
        rebuildProvinces();
        resetRates();
      });
      province.addEventListener('change', resetRates);
      provinceText.addEventListener('input', resetRates);
      zip.addEventListener('input', resetRates);
      customerName.addEventListener('input', resetRates);
      companyName.addEventListener('input', resetRates);
      customerEmail.addEventListener('input', resetRates);
      customerNotes.addEventListener('input', resetRates);
      discountInput.addEventListener('input', () => {
        if (discountInput.value.trim().toLowerCase() !== activeDiscountCode.toLowerCase()) {
          activeDiscountCode = '';
          try {
            window.sessionStorage.removeItem('ucPrintQuoteDiscountCode');
          } catch (error) {
          }
        }
        resetRates();
      });

      Object.values(readNotificationQueue()).forEach((payload) => {
        if (payload && typeof payload === 'object' && payload.quoteNumber) {
          void sendQuoteNotification(payload);
        }
      });

      try {
        const savedDiscountCode = window.sessionStorage.getItem('ucPrintQuoteDiscountCode');
        if (savedDiscountCode) {
          discountInput.value = savedDiscountCode;
          setDiscountStatus(root.dataset.discountCheckoutMessage);
        }
      } catch (error) {
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uc-quote-guide-prompt"] && !Shopify.designMode) return;
  try {
    (() => {
    const prompt = document.querySelector('[data-uc-quote-guide-prompt]');
    if (!prompt) return;

    const close = prompt.querySelector('[data-uc-quote-guide-close]');
    let dismissTimer;

    const dismiss = () => {
      window.clearTimeout(dismissTimer);
      prompt.classList.remove('is-visible', 'is-waving');
    };

    const scheduleDismiss = (delay = 8000) => {
      window.clearTimeout(dismissTimer);
      dismissTimer = window.setTimeout(dismiss, delay);
    };

    const show = () => {
      prompt.classList.add('is-visible', 'is-waving');
      scheduleDismiss();
    };

    close?.addEventListener('click', dismiss);
    prompt.addEventListener('pointerenter', () => window.clearTimeout(dismissTimer));
    prompt.addEventListener('pointerleave', () => scheduleDismiss(4000));
    prompt.addEventListener('focusin', () => window.clearTimeout(dismissTimer));
    prompt.addEventListener('focusout', () => scheduleDismiss(4000));
    window.setTimeout(show, 1600);
  })();
  } catch(e) { console.error(e); }
})();

})();
